module.exports = __webpack_public_path__ + "img/face41.b354c96e.gif";